var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":"Rayon (mètres)*","message":_vm.error,"type":_vm.error !== null ? 'is-danger' : ''}},[_c('b-input',{attrs:{"value":_vm.radius,"type":"number","min":_vm.minRadius},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }